var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import Debounce from "debounce-decorator";
import { Icon, Animate, Loader } from "sb-resp-ui";
import * as CMP from "./components";
// import DevTools from "mobx-react-devtools";
// import { setLogEnabled, setUpdatesEnabled, setGraphEnabled } from "mobx-react-devtools";
// if (process.env.NODE_ENV === "development") {
//     setLogEnabled(true);
//     setUpdatesEnabled(true);
//     setGraphEnabled(true);
// }
/* TODO(developer): refactor to lower cyclomatic complexity */
/* tslint:disable:cyclomatic-complexity */
var defaultStep = 450;
var RacingNextRaces = /** @class */ (function (_super) {
    __extends(RacingNextRaces, _super);
    function RacingNextRaces(props) {
        var _this = _super.call(this, props) || this;
        _this.calcs = {
            step: defaultStep,
            container: 0,
            wrapper: 0
        };
        _this.anims = { left: 0 };
        _this.dict = _this.props.dict;
        _this.state = {
            scrollable: {
                left: false,
                right: false
            },
            anims: { animation: { left: "0px" }, duration: 600, easing: [10, 5] },
            dataProvider: _this.props.dataProvider
        };
        _this.cachedState = {
            branchId: _this.state.dataProvider.racingStore.branchId,
            regionId: _this.state.dataProvider.racingStore.regionId
        };
        return _this;
    }
    /* istanbul ignore next */
    RacingNextRaces.prototype.renderCardItem = function (item) {
        /* istanbul ignore next */
        return (React.createElement(CMP.Item, { key: item.id, url: item.url, handler: function (event) { item.handler(event); }, label: this.dict.ViewAll },
            React.createElement(CMP.Name, { title: item.title, hasLiveStream: item.hasLiveStream }),
            item.rows.length > 0 && this.renderCardRows(item.rows),
            item.rows.length === 0 && this.renderLoader(true)));
    };
    /* istanbul ignore next */
    RacingNextRaces.prototype.renderCardRow = function (row) {
        var betButtonOdds = row.odds;
        if (row.isNR) {
            betButtonOdds = this.props.dict.NonRunner;
        }
        else if (row.isSP) {
            betButtonOdds = this.props.dict.StartingPrice;
        }
        var chosenClass = this.state.dataProvider.isLineInBetSlip(row.id, row.eventId) ? "chosenBet" : "";
        var modifier = "rj-racing-next-races__button " + this.state.dataProvider.provider.getUniqueOddsClass(row.id, true) + " " + chosenClass + " ";
        /* istanbul ignore next */
        return (React.createElement(CMP.Row, { id: row.id, key: row.id },
            React.createElement(CMP.Silk, { src: row.src }),
            React.createElement(CMP.Fixture, { top: row.fixture.top, bottom: row.fixture.bottom }),
            React.createElement(CMP.BetBtn, { odds: betButtonOdds, modifier: modifier, handler: row.handler, isDisabled: row.isNR })));
    };
    /* istanbul ignore next */
    RacingNextRaces.prototype.renderCardRows = function (rows) {
        var _this = this;
        /* istanbul ignore next */
        return (React.createElement("div", { className: "rj-racing-next-races__rows", style: { height: this.state.dataProvider.nextRacesRowsHeight + "px" } }, rows.map(function (x) {
            /* istanbul ignore next */
            return _this.renderCardRow(x);
        })));
    };
    /* istanbul ignore next */
    RacingNextRaces.prototype.renderLoader = function (shouldSetStyles) {
        var styles = shouldSetStyles ? { height: this.state.dataProvider.nextRacesRowsHeight + "px" } : {};
        return (React.createElement("div", { className: "rj-racing-next-races__loader", style: styles },
            React.createElement(Loader, null)));
    };
    /* istanbul ignore next */
    RacingNextRaces.prototype.renderCardItems = function (items) {
        var _this = this;
        /* istanbul ignore next */
        return items.map(function (x) {
            /* istanbul ignore next */
            return _this.renderCardItem(x);
        });
    };
    /* istanbul ignore next */
    RacingNextRaces.prototype.scrollLeft = function () {
        /* istanbul ignore next */
        var t = this.anims.left + this.calcs.step;
        /* istanbul ignore next */
        this.anims.left = t > 0 ? 0 : t;
        /* istanbul ignore next */
        var o = __assign({}, this.state.anims, { animation: { left: this.anims.left.toString() + "px" } });
        /* istanbul ignore next */
        this.setState({ anims: __assign({}, o) });
    };
    /* istanbul ignore next */
    RacingNextRaces.prototype.scrollRight = function () {
        /* istanbul ignore next */
        var t = this.anims.left - this.calcs.step;
        /* istanbul ignore next */
        var d = this.calcs.container - this.calcs.wrapper;
        /* istanbul ignore next */
        this.anims.left = Math.abs(t) > d ? d * -1 : t;
        /* istanbul ignore next */
        var o = __assign({}, this.state.anims, { animation: { left: this.anims.left.toString() + "px" } });
        /* istanbul ignore next */
        this.setState({ anims: __assign({}, o) });
    };
    /* istanbul ignore next */
    RacingNextRaces.prototype.onClickArrowsHandler = function (direction, e) {
        /* istanbul ignore next */
        return this["scroll" + direction]();
    };
    // to be used for routing between captured events
    /* istanbul ignore next */
    RacingNextRaces.prototype.handleEvent = function (e) {
        /* istanbul ignore next */
        if (e.type === "resize") {
            this.resetScroll();
            this.shouldScroll();
        }
    };
    /* istanbul ignore next */
    RacingNextRaces.prototype.resetScroll = function () {
        this.anims.left = 0;
        this.setState({ anims: __assign({}, this.state.anims, { animation: { left: "0px" } }) });
    };
    /* istanbul ignore next */
    RacingNextRaces.prototype.shouldScroll = function () {
        if (this.races__container && this.races__wrapper) {
            var sLeft = this.anims.left < 0 ? true : false;
            var sRight = this.calcs.container - this.calcs.wrapper + this.anims.left > 0 ? true : false;
            if (this.state.scrollable.left !== sLeft ||
                this.state.scrollable.right !== sRight) {
                this.setState({
                    scrollable: {
                        left: sLeft,
                        right: sRight
                    }
                });
            }
        }
    };
    /* istanbul ignore next */
    RacingNextRaces.prototype.setupCalcs = function () {
        if (this.races__container && this.races__wrapper) {
            this.calcs.container = this.races__container.offsetWidth;
            this.calcs.wrapper = this.races__wrapper.offsetWidth;
            var items = this.races__container.querySelectorAll(".rj-racing-next-races__item");
            var i = items[0]["offsetWidth"];
            var dI = i * items.length;
            var dC = (this.calcs.container - dI) / (items.length - 1);
            this.calcs.step = i + dC;
        }
    };
    /* istanbul ignore next */
    RacingNextRaces.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this);
    };
    /* istanbul ignore next */
    RacingNextRaces.prototype.componentDidMount = function () {
        this.setupCalcs();
        this.shouldScroll();
        window.addEventListener("resize", this);
    };
    /* istanbul ignore next */
    RacingNextRaces.prototype.getSnapshotBeforeUpdate = function (prevProps, prevState) {
        if (this.cachedState.branchId !== this.state.dataProvider.racingStore.branchId ||
            this.cachedState.regionId !== this.state.dataProvider.racingStore.regionId) {
            return {
                branchId: this.state.dataProvider.racingStore.branchId,
                regionId: this.state.dataProvider.racingStore.regionId
            };
        }
        /* tslint:disable:no-null-keyword */
        return null;
        /* tslint:enable:no-null-keyword */
    };
    /* istanbul ignore next */
    RacingNextRaces.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        if (snapshot !== null) {
            this.cachedState = snapshot;
            this.resetScroll();
        }
        this.setupCalcs();
        this.shouldScroll();
    };
    /* istanbul ignore next */
    RacingNextRaces.prototype.render = function () {
        var _this = this;
        var l = this.state.dataProvider.getNextRaces.length;
        var cls = "rj-racing-next-races rj-racing-next-races--nextGames";
        cls += this.state.scrollable.left ? " rj-racing-next-races--sLeft" : "";
        cls += this.state.scrollable.right ? " rj-racing-next-races--sRight" : "";
        return (React.createElement(React.Fragment, null, this.state.dataProvider.racingStore.isNextRacesAvailable &&
            React.createElement("div", { className: cls },
                React.createElement(CMP.Heading, { more: this.dict.ViewNextCoupons, title: this.dict.NextRaces.format(this.state.dataProvider.getNextRaces.length) }),
                React.createElement("div", { className: "rj-racing-next-races__wrapper", ref: function (n) { return _this.races__wrapper = n; } },
                    (!l && !this.state.dataProvider.isDataLoaded) && this.renderLoader(),
                    (l > 0) && (React.createElement(Animate, __assign({}, this.state.anims),
                        React.createElement("div", { className: "rj-racing-next-races__container", ref: function (n) { return _this.races__container = n; } }, this.renderCardItems(this.state.dataProvider.getNextRaces))))),
                (l > 0 && this.state.dataProvider.isDataLoaded) && React.createElement(CMP.Arrow, { handler: this.onClickArrowsHandler.bind(this, "Left"), classModifier: "left", text: React.createElement(Icon, { i: "i-12 arrow-flat-left" }) }),
                (l > 0 && this.state.dataProvider.isDataLoaded) && React.createElement(CMP.Arrow, { handler: this.onClickArrowsHandler.bind(this, "Right"), classModifier: "right", text: React.createElement(Icon, { i: "i-12 arrow-flat-right" }) }))));
    };
    __decorate([
        Debounce(50),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, MouseEvent]),
        __metadata("design:returntype", void 0)
    ], RacingNextRaces.prototype, "onClickArrowsHandler", null);
    __decorate([
        Debounce(50),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Event]),
        __metadata("design:returntype", void 0)
    ], RacingNextRaces.prototype, "handleEvent", null);
    __decorate([
        Debounce(50),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RacingNextRaces.prototype, "shouldScroll", null);
    RacingNextRaces = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], RacingNextRaces);
    return RacingNextRaces;
}(React.Component));
export { RacingNextRaces };
//# sourceMappingURL=RacingNextRaces.js.map